const SnackbarModule = {
  namespaced: true,
  state: () => ({
    content: "",
    color: ""
  }),
  actions: {},
  getters: {},
  mutations: {
    showMessage(state, payload) {
      state.content = payload.content;
      state.color = payload.color;
    }
  }
};
export default SnackbarModule;
